/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface AdditionalWorkListAdmin
 */
export interface AdditionalWorkListAdmin {
  /**
   *
   * @type {number}
   * @memberof AdditionalWorkListAdmin
   */
  readonly id: number
  /**
   *
   * @type {string}
   * @memberof AdditionalWorkListAdmin
   */
  name?: string
  /**
   *
   * @type {number}
   * @memberof AdditionalWorkListAdmin
   */
  price?: number | null
  /**
   *
   * @type {string}
   * @memberof AdditionalWorkListAdmin
   */
  measureUnit?: string | null
  /**
   *
   * @type {string}
   * @memberof AdditionalWorkListAdmin
   */
  slug?: string | null
}

/**
 * Check if a given object implements the AdditionalWorkListAdmin interface.
 */
export function instanceOfAdditionalWorkListAdmin(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'id' in value

  return isInstance
}

export function AdditionalWorkListAdminFromJSON(json: any): AdditionalWorkListAdmin {
  return AdditionalWorkListAdminFromJSONTyped(json, false)
}

export function AdditionalWorkListAdminFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AdditionalWorkListAdmin {
  if (json === undefined || json === null) {
    return json
  }
  return {
    id: json['id'],
    name: !exists(json, 'name') ? undefined : json['name'],
    price: !exists(json, 'price') ? undefined : json['price'],
    measureUnit: !exists(json, 'measureUnit') ? undefined : json['measureUnit'],
    slug: !exists(json, 'slug') ? undefined : json['slug'],
  }
}

export function AdditionalWorkListAdminToJSON(value?: AdditionalWorkListAdmin | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    name: value.name,
    price: value.price,
    measureUnit: value.measureUnit,
    slug: value.slug,
  }
}
